import _ from 'lodash'
import qs from 'qs'
import { push } from 'react-router-redux'
import { toast } from 'react-toastify'

import api from '../lib/api'

export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS'
export const CREATE_PROJECT_FAILURE = 'CREATE_PROJECT_FAILURE'
export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS'
export const UPDATE_PROJECT_FAILURE = 'UPDATE_PROJECT_FAILURE'
export const READ_PROJECT_SUCCESS = 'READ_PROJECT_SUCCESS'
export const READ_PROJECT_FAILURE = 'READ_PROJECT_FAILURE'
export const LIST_PROJECTS_SUCCESS = 'LIST_PROJECTS_SUCCESS'
export const LIST_PROJECTS_FAILURE = 'LIST_PROJECTS_FAILURE'
export const CLEAR_PROJECT_SUCCESS = 'CLEAR_PROJECT_SUCCESS'
export const CLEAR_PROJECT_KEY_SUCCESS = 'CLEAR_PROJECT_KEY_SUCCESS'
export const SET_PROJECT_ERRORS_SUCCESS = 'SET_PROJECT_ERRORS_SUCCESS'
export const CLEAR_PROJECT_ERRORS_SUCCESS = 'CLEAR_PROJECT_ERRORS_SUCCESS'
export const GET_USER_FROM_PROJECT = 'GET_USER_FROM_PROJECT'

export const createProject = (project) => async dispatch => {
  try {
    const formData = new FormData()
    formData.append('name', project.name)
    formData.append('description', project.description)
    formData.append('image', project.image)
    formData.append('collaborators', project.collaborators)
    formData.append('adminCollaborators', project.adminCollaborators)
    await api.post('/api/projects', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    await dispatch({ type: CREATE_PROJECT_SUCCESS })
    dispatch(push('/project'))
  } catch (err) {
    toast.error('Failed to create a project.')
    console.log(err.msg)
    dispatch({ type: CREATE_PROJECT_FAILURE, err })
  }
}

export const updateProject = (project) => async dispatch => {
  try {
    const formData = new FormData()
    formData.append('name', project.name)
    formData.append('description', project.description)
    formData.append('image', project.image)
    formData.append('collaborators', project.collaborators)
    formData.append('adminCollaborators', project.adminCollaborators)
    await api.put(`/api/projects/${project.id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    await dispatch({ type: UPDATE_PROJECT_SUCCESS })
    dispatch(push('/project'))
  } catch (err) {
    toast.error('Failed to update the project.')
    console.log(err.msg)
    dispatch({ type: UPDATE_PROJECT_FAILURE, err })
  }
}

export const readProject = (projectId) => async dispatch => {
  try {
    dispatch({ type: CLEAR_PROJECT_SUCCESS })
    const { data } = await api.get(`/api/projects/${projectId}`)
    dispatch({ type: READ_PROJECT_SUCCESS, data: { current: data } })
  } catch (err) {
    toast.error('Failed to retrieve the project.')
    console.log(err.msg)
    dispatch({ type: READ_PROJECT_FAILURE, err })
  }
}

export const listProjects = (query, key) => async dispatch => {
  try {
    const defaultQuery = { limit: process.env.REACT_APP_PAGE_LIMIT, page: 1 }
    const { data } = await api.get(`/api/projects?${qs.stringify(_.merge(defaultQuery, query))}`)
    dispatch({ type: LIST_PROJECTS_SUCCESS, data: { query, list: data, key } })
  } catch (err) {
    toast.error('Failed to retrieve the list of the projects.')
    console.log(err.msg)
    dispatch({ type: LIST_PROJECTS_FAILURE, err })
  }
}

export const clearProjectKey = (key) => dispatch => {
  dispatch({ type: CLEAR_PROJECT_KEY_SUCCESS, data: { key } })
}

export const setProjectErrors = (errors) => dispatch => {
  dispatch({ type: SET_PROJECT_ERRORS_SUCCESS, data: { errors } })
}

export const clearProjectErrors = () => dispatch => {
  dispatch({ type: CLEAR_PROJECT_ERRORS_SUCCESS })
}

export const getUserFromProject = (projectId) => async dispatch => {
  try {
      const { data } = await api.get(`/api/projects/${projectId}`)
      dispatch({ type: GET_USER_FROM_PROJECT, data: { users: data.users } })
  } catch (err) {
      toast.error('Failed to retrieve the project.')
      console.log(err.msg)
      dispatch({ type: READ_PROJECT_FAILURE, err })
  }
}


// WEBPACK FOOTER //
// ./src/actions/project.js